import { render, staticRenderFns } from "./standardList.vue?vue&type=template&id=404d2246&scoped=true"
import script from "./standardList.vue?vue&type=script&lang=js"
export * from "./standardList.vue?vue&type=script&lang=js"
import style0 from "./standardList.vue?vue&type=style&index=0&id=404d2246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d2246",
  null
  
)

export default component.exports